<template>
	<tr :class="offerIsActive ? '' : 'bg-gray-200'">
		<td class="pl-6 pr-2 py-4">
			<div
				v-if="offer.trade == 'SELL'"
				class="rounded-full w-5 h-5"
				:class="'bg-green-500'"
			></div>
			<div v-else>
				<div
					v-if="offer.visible"
					class="w-5 h-5"
					:class="'bg-orange-500'"
				></div>
				<div v-else class="bg-white border-2 border-orange-500 w-5 h-5">
					<div class="bg-orange-500 w-2 h-2 m-1 mb-3"></div>
				</div>
			</div>
		</td>
		<td
			class="pl-2 pr-2 py-4 font-medium leading-5"
			:class="offerIsActive ? 'text-gray-900' : 'text-gray-500'"
		>
			<!-- :class="offer.trade == 'SELL' ? 'text-green-500' : 'text-orange-500'" -->
			<!-- {{ offer.trade }} -->
			<!-- <crop-product-summary :tradable="offer" /> -->

			{{ offerLabel }}

			<!-- <br /> -->
			<!-- {{ __('Harvest') }}  -->
			<span
				class="text-sm whitespace-nowrap"
				:class="offerIsActive ? 'text-gray-500' : 'text-gray-400'"
				>{{ offer.product.origin }}
				{{ offer.product.harvest || __("n.a.") }}</span
			>
		</td>
		<td
			class="px-2 py-4 text-sm xl:text-base"
			:class="offerIsActive ? 'text-gray-500' : 'text-gray-400'"
		>
			<div
				v-if="!showDateInput"
				:class="offerIsExpired ? 'text-red-600 font-medium' : ''"
			>
				{{ $cropOptions.dateToString(offer, locale, true) }}

				<button
					v-if="!auctionIsActive"
					v-on:click.prevent="showDateInput = true"
					class="inline-flex gap-x-2 whitespace-nowrap"
				>
					<ui-icon name="edit-3" stroke-width="2" class="w-5 h-5 text-orange" />
				</button>
			</div>
			<div v-else>
				<my-lots-edit-date
					:form="form"
					:offer="offer"
					:idx="idx"
					:field-prefix="f"
					:no-label="true"
				/>
			</div>
		</td>
		<td
			class="px-2 py-4 text-sm xl:text-base"
			:class="offerIsActive ? 'text-gray-500' : 'text-gray-400'"
		>
			{{
				$cropOptions.getLocalizedLabel(
					offer.location.mode,
					$cropOptions.locationModeOptions
				)
			}}
			{{ offer.location.address.zip }}
			{{ offer.location.address.city }}
		</td>
		<td
			class="px-2 py-4"
			:class="offerIsActive ? 'text-gray-500' : 'opacity-50'"
			v-if="showPriceIndication"
		>
			<div
				v-if="offer.priceindication && offer.priceindication.enabled"
				class="min-w-[4.5rem]"
			>
				<div v-if="!showDistanceInput">
					<button
						v-on:click.prevent="showDistanceInput = true"
						class="inline-flex gap-x-2 whitespace-nowrap"
					>
						<span v-if="offer.priceindication.distance_max"
							>{{ offer.priceindication.distance_max }} km</span
						>
						<span v-else class="text-center text-5xl">-</span>
						<ui-icon
							v-if="!auctionIsActive"
							name="edit-3"
							stroke-width="2"
							class="w-5 h-5 text-orange"
						/>
					</button>
				</div>
				<div v-else>
					<ui-input-group
						:no-label="true"
						:required="true"
						:form="form"
						@change="piNeedsUpdate = true"
						v-on:input="checkMaxDistance"
						:field="f + 'priceindication.distance_max'"
						v-model="offer.priceindication.distance_max"
						:maxValue="maxKm"
						suffix="km"
						class="min-w-[3rem] max-w-[6rem] -mt-1"
					/>
				</div>
			</div>
			<div v-else class="text-center text-5xl">-</div>
		</td>
		<td
			v-else
			class="px-2 py-4 whitespace-nowrap"
			:class="offerIsActive ? 'text-gray-500' : 'text-gray-400'"
		></td>
		<td
			class="px-2 py-4 whitespace-nowrap"
			:class="offerIsActive ? 'text-gray-500' : 'opacity-50'"
		>
			<ui-input-group
				:no-label="true"
				:required="true"
				:form="form"
				:field="f + 'qty.mt'"
				v-model="offer.qty.mt"
				suffix="t"
				class="min-w-[4rem] max-w-[6rem] -mt-1"
				:showAsInvalid="offerHasNoQty"
				:disabled="auctionIsActive"
				:showZeroValue="true"
			/>
		</td>
		<td
			class="px-2 py-4 whitespace-nowrap"
			:class="offerIsActive ? 'text-gray-500' : 'opacity-50'"
		>
			<ui-select
				class="w-[7rem]"
				v-model="pricingStrategy"
				:options="pricingStrategyOptions"
				@change="piNeedsUpdate = true"
				:allow-empty="false"
				:markInvalid="commodityIsExpired"
				:disabled="auctionIsActive"
			/>
		</td>

		<td
			class="px-2 py-4 whitespace-nowrap"
			:class="offerIsActive ? 'text-gray-500' : 'opacity-50'"
		>
			<ui-validation-message :form="form" :field="f + 'price'" />
			<span v-if="offer.price.type == 'FLAT'">
				<ui-input-group
					:no-label="true"
					:required="true"
					:form="form"
					:field="f + 'price.mt'"
					@change="piNeedsUpdate = true"
					v-model="offer.price.mt"
					class="min-w-[6rem] max-w-[6rem] -mt-1"
					:dp="2"
					suffix="€/t"
					:disabled="auctionIsActive"
				/>
			</span>
			<span
				v-else-if="offer.price.type == 'INDEXED'"
				class="flex gap-x-2 items-center"
			>
				<ui-input-group
					:no-label="true"
					:required="true"
					:form="form"
					:field="f + 'price.basis'"
					@change="piNeedsUpdate = true"
					v-model="offer.price.basis"
					class="min-w-[5.5rem] max-w-[6rem] -mt-1"
					:dp="2"
					suffix="€/t"
					:disabled="auctionIsActive"
				/>
			</span>
		</td>

		<!--
        <td class="px-2 py-4" v-if="showPriceIndication">
            <input type="checkbox" v-if="offerHasPriceIndication" v-model="form.offers[idx].priceindication.fixedprice"
                class="mt-0.5 h-5 w-5 border-gray-300 hover:border-gray-500 rounded text-orange-500 focus:ring-orange-500 cursor-pointer" />
        </td>
        -->

		<td
			class="pl-2 pr-6 py-4"
			:class="offerIsActive ? 'text-gray-500' : 'text-gray-400'"
			v-if="showPriceIndication"
		>
			<div
				class="flex items-center text-xs gap-x-4 justify-between"
				v-if="offerHasPriceIndication"
			>
				<div class="min-w-[3.5rem] text-right">
					<span v-if="newPriceIndicationActive && piNeedsUpdate">
						wird aktualisiert<br />
					</span>
					<!--span
						v-if="
							oldPriceIndicationStatus == 'ACTIVE' &&
							newPriceIndicationActive &&
							priceIndicationStat
						"
					>
						{{ priceIndicationStat.sum_indications }} Landwirte erreicht<br />
						<span
							class="font-semibold whitespace-nowrap"
							:class="
								priceIndicationStat.sum_best_price > 0
									? 'text-green-500'
									: 'text-red-600'
							"
							>{{ priceIndicationStat.sum_best_price }} x Bestpreis</span
						>
					</span-->
					<!--
                    // FIXME strange reactivity problem with newPriceIndicationActive not being updated. getter not called
                    // compare with pricingStrategy, where everything works as expected...
                    <span v-if="oldPriceIndicationStatus == 'ACTIVE' && !newPriceIndicationActive">
                        wird deaktiviert
                    </span>
                    <span v-if="oldPriceIndicationStatus == null && newPriceIndicationActive">
                        wird aktiviert
                    </span>
                    -->
					<!--span v-if="oldPriceIndicationStatus == 'INPROGRESS'">
						{{ __("In Progress") }}
					</span>
					<span v-if="oldPriceIndicationStatus == 'PENDING'">
						{{ __("Pending") }}
					</span-->
				</div>
				<span
					v-if="
						oldPriceIndicationStatus == 'INPROGRESS' ||
						oldPriceIndicationStatus == 'PENDING'
					"
				>
					<ui-icon
						:class="[
							'mr-4 md:mr-3 flex-shrink-0 h-7 w-7 text-2xl animate-spin',
						]"
						name="fa-spinner"
						stroke-width="2"
					/>
				</span>

				<input
					type="checkbox"
					v-model="newPriceIndicationActive"
					@change="piNeedsUpdate = true"
					v-if="!['PENDING', 'INPROGRESS'].includes(oldPriceIndicationStatus)"
					class="mt-0.5 h-5 w-5 border-gray-300 hover:border-gray-500 rounded text-orange-500 focus:ring-orange-500 cursor-pointer pi-cb"
					:class="offerIsActive ? '' : 'bg-gray-200'"
					:disabled="!offerIsActive"
				/>
			</div>
			<div v-else class="text-right text-5xl">-</div>
		</td>
	</tr>
</template>

<script>
export default {
	props: {
		offer: {
			type: Object,
			required: true,
		},
		form: {
			type: Object,
			required: true,
		},
		idx: {
			type: Number,
			required: true,
		},
		showPriceIndication: {
			type: Boolean,
			default: false,
		},
		activeFutures: {
			type: Array,
			required: true,
		},
		inactiveFutures: {
			type: Array,
			required: true,
		},
		priceIndicationStat: {
			type: Object,
		},
		auctionMyLotsState: {
			type: String,
			required: false,
		},
	},
	data() {
		return {
			oldPriceIndicationStatus: this.offer.priceindication?.status,
			showDistanceInput: true,
			showDateInput: false,
			piNeedsUpdate: this.form.offers[this.idx]._priceindication_needs_update,
			maxKm: 250,
		};
	},
	computed: {
		f() {
			// prefix for the validation key
			return "offers." + this.idx + ".";
		},
		futuresOptions() {
			let tickers = {
					RAPE: "ECO",
					MAIZE: "EMA",
					FABA: null, // no futures available for FABA and PEA
					PEA: null,
				},
				desiredTicker = tickers[this.offer.product.type] || "EBM";
			let futures = this.commodityIsExpired
				? this.activeFutures.concat(this.inactiveFutures)
				: this.activeFutures;
			let that = this;
			return (futures || [])
				.filter((f) =>
					that.offer.product.type == "MAIZE"
						? (!f.expired &&
								(f.ticker_code == desiredTicker || f.ticker_code == "EBM")) ||
						  that.offer.price.commodity_future_id == f.id
						: (!f.expired && f.ticker_code == desiredTicker) ||
						  that.offer.price.commodity_future_id == f.id
				)
				.sort((a, b) =>
					a.ticker_code > b.ticker_code
						? 1
						: b.ticker_code > a.ticker_code
						? -1
						: 0
				);
		},
		pricingStrategyOptions() {
			let o = [{ id: "FLAT.", label: this.__("Flat Price") }],
				o2 = [];
			if (this.offer.trade == "BUY") {
				o2 = this.futuresOptions.map(function (f) {
					return {
						id: "INDEXED." + f.id,
						label: f.name,
					};
				});
			}
			return o.concat(o2);
		},

		// a pricing strategy is either flat or indexed.<commodity future id>
		pricingStrategy: {
			get() {
				if (this.offer.price.type == "FLAT") {
					return "FLAT.";
				} else if (this.offer.price.type == "INDEXED") {
					return "INDEXED." + this.offer.price.commodity_future_id;
				} else {
					throw "unknown price type: " + this.offer.price.type;
				}
			},
			set(v) {
				let [priceType, commodityFutureId] = v.split(".");
				this.form.offers[this.idx].price.type = priceType;
				this.form.offers[this.idx].price.commodity_future_id =
					commodityFutureId == "" ? null : commodityFutureId;
			},
		},

		newPriceIndicationActive: {
			// after the input and has been saved and any batch processes run, will the PI be active for this offer?
			get() {
				console.log("COMPUTING NPI");
				if (this.offer._priceindication_active) {
					return true;
				} else {
					return false;
				}
			},
			set(v) {
				console.log("NPI", v);
				this.form.offers[this.idx]._priceindication_active = v;
				if (
					this.form.offers[this.idx].priceindication.distance_max == null ||
					this.form.offers[this.idx].priceindication.distance_max == ""
				) {
					this.form.offers[this.idx].priceindication.distance_max = 150;
				}
			},
		},

		offerHasPriceIndication() {
			return this.offer.trade == "BUY" && this.offer.priceindication?.enabled;
		},

		offerHasErrors() {
			return (
				this.offerIsExpired || this.offerHasNoQty || this.commodityIsExpired
			);
		},
		offerIsExpired() {
			if (!this.offer.date.month_to) {
				return false;
			} else {
				var monthTo = new Date(this.offer.date.month_to);
				var lastDayOfMonth = new Date(
					monthTo.getFullYear(),
					monthTo.getMonth() + 1,
					0
				);
				return lastDayOfMonth < new Date();
			}
		},
		offerHasNoQty() {
			if (!this.offer.qty.mt || this.offer.qty.mt <= 0) {
				return true;
			}
			return false;
		},
		commodityIsExpired() {
			if (this.offer.commodityFuture && this.offer.commodityFuture.expired) {
				return true;
			}
			return false;
		},
		priceIndicationInProgress() {
			if (
				this.offer.priceindication.status == "PENDING" ||
				this.offer.priceindication.status == "INPROGRESS"
			) {
				return true;
			}
			return false;
		},
		auctionIsActive() {
			if (
				this.offer.trade == "SELL" &&
				this.auctionMyLotsState == "BIDDING" &&
				this.offer.auction.qty_mt > 0
			) {
				return true;
			}
			return false;
		},
		offerLabel() {
			if (
				this.offer.product.grade == "WHEAT_B__OTHER" &&
				this.offer.quality.protein_min !== ""
			) {
				return this.$cropOptions.getLocalizedWheatOtherLabel(
					this.offer.quality.protein_min
				);
			} else {
				return this.$cropOptions.getLocalizedLabel(
					this.offer.product.grade,
					this.$cropOptions.productGradeOptions
				);
			}
		},
		offerIsActive() {
			return (
				(this.offer.visible ||
					(!this.offer.visible && this.offer.trade == "BUY")) &&
				!this.auctionIsActive &&
				!this.offerHasErrors
			);
		},
	},
	watch: {
		piNeedsUpdate(v) {
			this.form.offers[this.idx]._priceindication_needs_update = v;
		},
	},

	methods: {
		checkMaxDistance() {
			if (
				parseInt(this.form.offers[this.idx].priceindication.distance_max) >
				this.maxKm
			) {
				this.offer.priceindication.distance_max = this.maxKm;
				alert(
					"Die maximale Entfernung darf nicht mehr als " +
						this.maxKm +
						"km betragen."
				);
			}
		},
	},
};
</script>
